<div class="topdiv compact-container">
  <!-- Header -->
  <div class="row mb-1">
    <div class="col-lg">
      <label class="textColour compact-title">Re-authenticate</label>
    </div>
  </div>

  <form novalidate [formGroup]="validations_form">

    <!-- <div class="row compact-row">
      <div class="col-lg-12">
        <mat-form-field appearance="outline" class="compact-field">
          <mat-label>Username</mat-label>
          <input matInput type="text" formControlName="username" readonly />
        </mat-form-field>
      </div>
    </div> -->

    <div class="row compact-row">
      <div class="col-lg-12">
        <mat-form-field appearance="outline" class="compact-field">
          <mat-label>Password</mat-label>

          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            autocomplete="new-password"
          />

          <mat-icon matSuffix class="eyecon" (click)="togglePassword()">
            {{ hidePassword ? "visibility_off" : "visibility" }}
          </mat-icon>
                     <mat-error *ngIf="validations_form.get('password')?.hasError('required')">Password is required</mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- <div class="row compact-row">
      <div class="col-lg-12">
        <mat-form-field appearance="outline" class="compact-field">
          <mat-label>Select Role</mat-label>
          <mat-select formControlName="role">
            <mat-option *ngFor="let obj of rolelist" [value]="obj.rolename">
              {{ obj.rolename }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row compact-row">
      <div class="col-lg-12">
        <mat-form-field appearance="outline" class="compact-field">
          <mat-label>Comment</mat-label>
          <input matInput type="text" formControlName="comment" />
        </mat-form-field>
      </div>
    </div> -->

    <!-- Buttons -->
    <div class="compact-actions">
      <!-- <button class="actionButton" (click)="save()">Authenticate</button>
      <button class="cancelButton" (click)="cancel()">Cancel</button> -->
      				  <!-- <button i18n="@@TargetClear" type="button" (click)="save()"
                    class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:130px;color: white;">Authenticate</button> -->
                    <app-common-button
                    label="Authenticate"
                    title="Authenticate"
                    icon="fas fa-user-check" 
                    [critical]="false"
                    [buttonId]="1111"             
                    width="130px"
                    (clicked)="save()"
                    height="34px"
                    style="margin-left: 6px; margin-right: 6px; color: white;">
                    </app-common-button>
                    
                     <app-common-button
                      label="Cancel"
                      title="Cancel"          
                      [critical]="false"
                      [buttonId]="1111"  
                      width="130px"
                      (clicked)="cancel()"
                      height="34px"
                      style="margin-left: 6px; margin-right: 6px; color: white; padding: .3rem 1.6rem; font-size: .85rem;">
                      </app-common-button>

            <!-- <button i18n="@@TargetCancel" type="button" (click)="cancel()"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:130px;color: white;">Cancel</button> -->
    </div>

  </form>
</div>
